import * as React from 'react';

import styles from './calendar-year-picker.module.css';

type Props = {
    onChange: (arg1: number) => void;
    year: number | null | undefined;
    isLightMode?: boolean | null | undefined;
};

export const CalendarYearPicker = (props: Props) => {
    const [isButton, setIsButton] = React.useState<boolean>(true);
    const [yearInput, setYearInput] = React.useState<number | null | undefined>(props.year);

    React.useEffect(() => {
        setYearInput(props.year);
    }, [props.year]);

    // @ts-expect-error
    const handleButtonClick = (e) => {
        e.stopPropagation();
        setIsButton(false);
    };

    // @ts-expect-error
    const handleSubmit = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        setIsButton(true);

        if (yearInput) {
            const fourDigitYear = yearInput < 100 ? Number(yearInput) + 2000 : yearInput;
            props.onChange(fourDigitYear);
        }
    };

    if (isButton) {
        return (
            <button
                onClick={handleButtonClick}
                className={props.isLightMode ? styles['button-light'] : styles['button']}
            >
                {props.year}
            </button>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <input
                name='year'
                type='number'
                // @ts-expect-error
                onChange={(e) => setYearInput(e.target.value)}
                onBlur={handleSubmit}
                // @ts-expect-error
                value={yearInput}
                autoFocus={true}
                className={styles['input']}
            />
        </form>
    );
};
